import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Footer.css';

// Import Logo (Replace with your actual logo path)
import logo from '../../assets/Logo.png';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">

        {/* --- TOP ROW: Logo & Newsletter --- */}
        <div className="footer-top">
          {/* Left: Logo */}
          <div className="footer-brand">
            <img src={logo} alt="Dazbog Logo" className="footer-logo" />
          </div>

        </div>

        {/* --- MIDDLE ROW: 4 Columns --- */}
        <div className="row footer-links-row">

          {/* Col 1: Company Links */}
          <div className="col-lg-2 col-md-4 mb-4 mb-lg-0">
            <h5 className="footer-col-title">Company</h5>
            <ul className="footer-links-list">
              <li><a href="#about" className="footer-link">About Us</a></li>
              <li><a href="#teams" className="footer-link">Teams</a></li>
              <li><a href="#careers" className="footer-link">Careers</a></li>
              <li><a href="#contact" className="footer-link">Contact</a></li>
            </ul>
          </div>

          {/* Col 3: US Address */}
          <div className="col-lg-4 col-md-6 mb-4 mb-lg-0 address-block">
            <h5 className="footer-col-title">DAZBOG POWER LLC (US)</h5>
            <p><strong>+91 91134 94483</strong></p>
            <p><strong>info@dazbog.us</strong></p>
            <p>
              Mitcham Square, Ashburn <br />
              Virginia, United States of America
            </p>
          </div>

          {/* Col 4: India Address */}
          <div className="col-lg-4 col-md-6 address-block">
            <h5 className="footer-col-title">DAZBOG POWER LLC (INDIA)</h5>
            <p><strong>+91 88009 54675</strong></p>
            <p><strong>info@dazbog.in</strong></p>
            <p>
              DLF Corporate Greens, Gurugram, <br />
              Haryana, India
            </p>
          </div>

        </div>

        {/* --- ICONS ROW --- */}
        <div className="footer-icon-row">

          {/* Icon 1: Email */}
          <div className="icon-item">
            <i className="bi bi-envelope footer-icon"></i>
            <span>info@dazbog.in</span>
          </div>

          {/* Icon 2: Phone */}
          <div className="icon-item">
            <i className="bi bi-telephone footer-icon"></i>
            <span>+91 88009 54675</span>
          </div>

          {/* Icon 3: Location */}
          <div className="icon-item">
            <i className="bi bi-geo-alt footer-icon"></i>
            <span>DLF Corporate Greens, Gurugram, Haryana, India</span>
          </div>

        </div>

        {/* --- BOTTOM ROW: Copyright & Legal --- */}
        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="copyright">
            Copyright © 2026 - All Rights Reserved
          </div>

          <div className="bottom-links">
            <a href="#terms">Terms and Conditions</a> |
            <a href="#privacy">Privacy Policy</a>
          </div>

          <div className="designer" style={{ color: "#c7c7c7" }}>
            Designed by Ascent Brandworks
          </div>


        </div>

      </div>
    </footer>
  );
};

export default Footer;